import { render, staticRenderFns } from "./MostradorDataHora.vue?vue&type=template&id=2733cf9e&scoped=true"
import script from "./MostradorDataHora.vue?vue&type=script&lang=js"
export * from "./MostradorDataHora.vue?vue&type=script&lang=js"
import style0 from "./MostradorDataHora.vue?vue&type=style&index=0&id=2733cf9e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2733cf9e",
  null
  
)

export default component.exports